const Spinner = ({ type = 'grow', color = 'primary', style = {} }) => {
  return (
    <div className={`spinner-${type} text-${color}`} role="status" style={style}>
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};

export default Spinner;
